$(function () {

  // page slug auto-generation
  $('#page_group_title').on('input', function () {
    var val = $(this).val();

    $('#page_group_slug').val(val.toLowerCase().replace(/[^0-9a-z-_]/g, '-'));
  });

  // previous nav disabled
  $('#page_group_previous_navigation_allowed').on('input', function () {
    var $this = $(this);

    $('.previous_buttons').find('input, select').attr('disabled', ($this.val() == 'false'));
  }).trigger('input');

  // Page Group Pages draggable/sortable component
  var $dragging = null;

  $('#allPages .form-field').draggable({
    handle: '.label',
    revert: 'invalid',
    helper: 'clone',
    revert: function (isValid) {
      if (isValid) {
        $dragging.hide();
      }
      $dragging.css('opacity', 1);
    },
    start: function (event, ui) {
      $dragging = $('#allPages').find('[data-id=' + ui.helper.data('id') + ']').not(ui.helper);
      $dragging.css('opacity', 0);
    },
    connectToSortable: '#pageGroupPages'
  });

  // checkbox switches
  var initSwitches = function initSwitches() {
    $('#pageGroupPages .switch_yes_no').each(function () {
      var $this = $(this);

      $this.bootstrapSwitch('destroy');

      $this.bootstrapSwitch({
        onText: I18n.t('yes'),
        offText: I18n.t('no'),
        size: 'small',
        state: $this.val() == 'true'
      }).on('switchChange.bootstrapSwitch', function () {
        //console.log('set state', $this.bootstrapSwitch('state'))
        $this.val($this.bootstrapSwitch('state'));
      });
    });
  };
  initSwitches();

  var updatePageGroupPagesSortable = function () {
      $('#pageGroupPages .form-field input.position').each(function (index, element) {
        $(this).val(index);
      });
      initSwitches();
  };

  $('#pageGroupPages').sortable({
    axis: 'y',
    handle: '.label',
    receive: function (event, ui) {
      $('#pageGroupPages .form-field').css('opacity', 1);
    },
    update: function () {
      updatePageGroupPagesSortable();
    }
  });

  // init update all sortable
  updatePageGroupPagesSortable();

  // remove button
  $('#pageGroupPages').on('click', '.remove.btn', function () {
    var pageId = $(this).parents('.form-field').data('id');

    $('#allPages .form-field[data-id=' + pageId + ']').show();
    $('#pageGroupPages .form-field[data-id=' + pageId + ']').remove();

    return false;
  });

  // edit button
  $('#pageGroupPages').on('click', '.edit.btn', function () {
    var pageId = $(this).parents('.form-field').data('id');

    // cache current values
    $(this).parents('.form-field').find('input, select').each(function () {
      $(this).data('value', $(this).val());
    });
    
    $('#allPages .form-field, #pageGroupPages .form-field, .page-button').not('[data-id=' + pageId + ']').addClass('disabled');
    $('#pageGroupPages .form-field[data-id=' + pageId + ']').find('.form-field-form').show().end().find('.form-field-view').hide();
    
    return false;
  });

  // cancel button
  $('#pageGroupPages').on('click', '.cancel.btn', function () {
    var pageId = $(this).parents('.form-field').data('id');

    //revert to cached values
    $(this).parents('.form-field').find('input, select').each(function () {
      var $this = $(this);
      if ($this.hasClass('switch_yes_no')) {
        $this.bootstrapSwitch('state', $this.data('value') == 'true');
      } else {
        $this.val($this.data('value'));
      }
    });    

    $('#allPages .form-field, #pageGroupPages .form-field, .page-button').not('[data-id=' + pageId + ']').removeClass('disabled');
    $('#pageGroupPages .form-field[data-id=' + pageId + ']').find('.form-field-form').hide().end().find('.form-field-view').show();
    
    return false;
  });

  // submit button
  $('#pageGroupPages').on('click', '.submit.btn', function () {
    var pageId = $(this).parents('.form-field').data('id');

    $('#allPages .form-field, #pageGroupPages .form-field, .page-button').not('[data-id=' + pageId + ']').removeClass('disabled');
    $('#pageGroupPages .form-field[data-id=' + pageId + ']').find('.form-field-form').hide().end().find('.form-field-view').show();
    
    return false;
  });

  $('form').on('submit', function () {
    $('#allPages').find('input, select').remove();
  });

});